/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ContactDesignerModal_tradeFirm = {
    readonly publicProfile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "ContactDesignerModal_tradeFirm";
};
export type ContactDesignerModal_tradeFirm$data = ContactDesignerModal_tradeFirm;
export type ContactDesignerModal_tradeFirm$key = {
    readonly " $data"?: ContactDesignerModal_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ContactDesignerModal_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ContactDesignerModal_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '3f263094306f61e1e3228a0ba6f46366';
export default node;
